<template>
  <b-nav-item v-b-tooltip.hover="$t('header.bookmark')" data-component="bookmark-menu">
    <div ref="iconWrapper">
      <b-icon-bookmark
        id="bookmark-popover"
        @click.prevent="getBookmarkURL"
        variant="light"
        class="menu-icon"
      />
    </div>
    <b-popover
      class="bookmark-popover"
      target="bookmark-popover"
      v-if="bookmarkURL != '' && showBookmarkPopover"
      :show="bookmarkURL != '' && showBookmarkPopover"
      triggers="click"
      placement="bottom"
    >
      <template v-slot:title>
        <strong>{{$t('header.bookmark')}}</strong>
      </template>
      <div ref="popoverLiner"> <!-- this is a liner to allow click inside popup detection, not ideal, but we can't get an html reference to the popup otherwise -->
        <b-row no-gutters class="mb-2 p-1">
          <b-col>{{$t('bookmark.prompt4')}}</b-col>
        </b-row>
        <b-row no-gutters class="p-1 w-100">
          <b-col>
            <div class="bookmark-copy">
              <b-input readonly
                id="bookmark-url"
                target="_blank"
                ref="bookmark-url"
                size="sm"
                type="url"
                v-model="this.bookmarkURL"
              ></b-input>
              <b-button
                id="copy-button"
                size="sm"
                variant="outline-secondary"
                @click="copyToClipboard"
              >
                <BIconClipboardPlus />
              </b-button>
              <b-tooltip target="copy-button" >{{$t('dsid.copy-clipboard')}}</b-tooltip>
            </div>
          </b-col>
        </b-row>
        <hr />
        <b-button variant="ptc-secondary" size="sm" @click.prevent="close">{{$t('button.cancel')}}</b-button>
      </div>
    </b-popover>

  </b-nav-item>
</template>
<script>
//---- components ---------
import ProjectHomeService from "@/app/services/projectHome.service";
//---- 3rd-parties --------
import { BIconBookmark, BIconClipboardPlus } from "bootstrap-vue";

export default {
  name: "bookmark-menu",
  components: { BIconBookmark, BIconClipboardPlus },
  data() {
    return {
      showBookmarkPopover: false,
      bookmarkURL: ""
    };
  },
  computed: {
    currentQuestName() {
      return this.$store.getters["projectData/currentQuest"].name;
    },
    tabs() {
      return this.$store.state.dsDashboard.dashboardTabs;
    }
  },
  destroyed() {
    document.removeEventListener("click", this.closeIfClickedOutside);
    document.removeEventListener("keydown", this.closeOnEscapeKey);
  },
  methods: {
    // get the bookmark url
    getBookmarkURL() {
      this.bookmarkURL = "";
      const reqParams = new FormData();
      // check if request from service sessions tab
      if (this.currentQuestName == "SERVICE_SESSIONS") {
        reqParams.append("fromPage", "ds");
        reqParams.append("hash", this.$route.hash);
      }
      // else request from callcenter
      else reqParams.append("fromPage", "search");
      // call the bookmark url
      ProjectHomeService.getBookmarkURL(reqParams).then(response => {
        if (response.data.bookmark) {
          this.bookmarkURL = response.data.bookmark;
          this.open();
        } else {
          this.close();
        }
      });
    },
    copyToClipboard() {
      var copyText = this.$refs["bookmark-url"];
      copyText.select();
      copyText.setSelectionRange(0, 99999); /*For mobile devices*/
      document.execCommand("copy");
      this.close();
    },
    open() {
      document.addEventListener("click", this.closeIfClickedOutside);
      document.addEventListener("keydown", this.closeOnEscapeKey);
      this.showBookmarkPopover = true;
    },
    closeOnEscapeKey(e) {
      if (e.key == "Escape") {
        this.close();
        return false;
      }
    },
    closeIfClickedOutside(e) {
      let popoverLiner = this.$refs.popoverLiner;

      if (!popoverLiner)
        return;

      // need to step up 2 levels because the popover reference is on our liner
      // from there we need to reach the popup level which will also include the 
      // popup title
      let popover = this.$refs.popoverLiner.parentElement.parentElement;
      let icon = this.$refs.iconWrapper.parentElement.parentElement;
      let target = e.target;
      if (popover != target && !popover.contains(target) && icon != target && !icon.contains(target)) {
        this.close();
        return false;
      }
    },
    close() {
      document.removeEventListener("click", this.closeIfClickedOutside);
      document.removeEventListener("keydown", this.closeOnEscapeKey);
      this.showBookmarkPopover = false;
    }
  }
};
</script>
<style scoped>
.bookmark-copy {
  display: flex;
}
.bookmark-copy button {
  margin-left: -1px;
}
.bookmark-popover {
  min-width: 450px;
}
</style>